
import { defineComponent, ref, onMounted, PropType, computed, h } from "vue";
import stc from "string-to-color";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { MdPerson, MdClose } from "@vicons/ionicons4";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters,
} from "@/store/enums/participationEnums";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters,
} from "@/store/enums/hosterEnums";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
  EventType as EventType
} from "@/store/enums/paramsEnums";

import groupHeaderModel from "@/core/models/share/status.interface";
import eventModel from "@/core/models/share/inviteEvent.interface";
import usrResponseStatusModel from "@/core/models/share/status.interface";
import ParticipantModal from "@/components/participant/modal/participantModal.vue";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import statusModel from "@/core/models/share/status.interface";
import { Pencil, CheckmarkDoneSharp, EyeSharp, Trash } from "@vicons/ionicons5";
import { NButton, NTag, NSpace, NIcon } from "naive-ui";
import { useStore } from "vuex";
export default defineComponent({
  name: "recordPage",
  components: {
    MdPerson,
    ParticipantModal,
    EyeSharp
  },
  props: {
    groupHeaders: {
      type: Array as PropType<Array<groupHeaderModel>>,
      required: true,
    },
    eventData: {
      type: Array as PropType<Array<eventModel>>,
      required: true,
    },
  },
  setup(props: any, context: any) {
    const store = useStore();
    const showModal = ref(false);
    const modalEventID = ref<string>("NULL");
    const type = EventType.Record ;
    
    const statusData = computed<Array<statusModel>>(
      () => store.getters[Module.desc + Getters.EventStatuses]
    );
    const showViewModal = ref(false);
    const event = ref<inviteEventModel>();
    function localdayjs( date: string) {
      return dayjs( date);
    }
    const recordTimeRange = computed(() => store.getters[Module.desc + Getters.MyRecordTimeRange]);
    function updateDatePicker(e:any)
    {
      store.dispatch(Module.desc + Actions.HandMyRecordEvents);
    }
   
    
    async function onDetail(eventid: inviteEventModel) {
      // await store.dispatch(
      //   ParticipationModule.desc +
      //     ParticipationActions.LoadEventSchedularCountWithMyResponse,
      //   eventid
      // );
      // await store.dispatch(
      //   HosterModule.desc + HosterActions.LoadInvitePerson,
      //   eventid
      // );


      await store.dispatch(
        HosterModule.desc + HosterActions.LoadInvitePerson,
        eventid?.EventHeaderId ?? ""
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.LoadInviteScheduler,
        eventid?.EventHeaderId ?? ""
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.LoadEventResponse,
        eventid?.EventHeaderId ?? ""
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.LoadEventSchedularWithCount,
        eventid?.EventHeaderId ?? ""
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.UpdateResolution,
        eventid
      );

      // console.log(eventid)
      
      showViewModal.value = true;
      modalEventID.value = eventid.EventHeaderId;
    }
    const data = computed<Array<inviteEventModel>>(
      () => store.getters[Module.desc + Getters.MyRecordEvents]
    );

    function stringColor(str: String, alpha: Boolean) {
      var colour = stc(str);
      return colour + (alpha ? "66" : "");
    }
    onMounted(() => {});

    return {
      statusData,
      dayjs,
      showModal,
      modalEventID,
      ParamEventStatus,
      ParamHasReply,
      recordTimeRange,
      updateDatePicker,
      data,
      pagination: {
        pageSize: 10,
      },
      showViewModal,
      event,
      stringColor,
      type,
      EventType,
      ParamIsResolution,
      onDetail
    }
  },
});
